import { Pipe, PipeTransform } from '@angular/core';
import { InsightMarkdownService } from './insight-markdown.service';

/**
 * Renders stored insight Markdown to sanitised HTML, e.g.
 *   `<div [innerHTML]="insight.m | insightMarkdown"></div>`
 *
 * Bind the result through `[innerHTML]`, never through `bypassSecurityTrustHtml`
 * — Angular's own sanitiser is a deliberate second layer here. See
 * {@link InsightMarkdownService} for what the first layer allows and why.
 *
 * Pure, so a body is parsed once per distinct string rather than on every
 * change-detection pass; Markdown parsing is not cheap enough to repeat.
 */
@Pipe({
  name: 'insightMarkdown',
  standalone: true,
})
export class InsightMarkdownPipe implements PipeTransform {
  constructor(private insightMarkdownService: InsightMarkdownService) {}

  transform(markdown: string | null | undefined): string {
    return this.insightMarkdownService.render(markdown);
  }
}
